// third party imports
import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";

// internal rebet imports
import "./stylesReports.css";
import { SIDER_TABS } from "../../utils/Constants";
import AffiliatePanelInstance from "../../api/AffiliatePanelInstance";

// component imports
import RebetLoader from "../CommonComponents/RebetLoader/RebetLoader";
import createPrivateAdminPanelInstance from "../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../api/ApiRoutes";
import Layout from "../CommonComponents/Layout/Layout";
import AppContext from "../../context/AppContext";

// asset imports

const Reports = () => {
  // non-state variables
  const token = JSON.parse(localStorage.getItem("token"));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.IdToken
  );
  const { setActiveSidebarTab } = useContext(AppContext);


  // state variables
  const [isApiRunning, setIsApiRunning] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [expandedReport, setExpandedReport] = useState(null);
  const [reports, setReports] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  const mockReports = [
    {
      reporter: {
        user_id: "2d323eaa-8c2b-400c-97d3-8b0452638378",
        username: "arvind",
      },
      reported_message: {
        message_id: "2bb4b0b3-cf86-49cf-b6aa-9a899ea526b6",
        chat_id: "rebet_global_chat",
        message_type: "text",
        content_url: "",
        content:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla nec purus feugiat, vestibulum nunc id, ultricies nunc. Nulla facilisi. Sed nec nunc nec nunc.",
        created_at: "2025-02-11T09:05:57.029936",
        sender: {
          user_id: "c68bf142-1b39-4e2b-81dc-d10592765e3a",
          username: "bva",
        },
      },
      report_reason: "False information",
      report_desc: "Test",
      created_at: "2025-02-13T06:45:34.829107",
      status: "open",
      context_before: [
        {
          message_id: "0e6ceaa9-afe8-4173-9591-7bd465c9e338",
          message_type: "text",
          content:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla nec purus feugiat, vestibulum nunc id, ultricies nunc. Nulla facilisi. Sed nec nunc nec nunc.",
          content_url: "",
          created_at: "2025-02-11T09:05:54.189344",
          sender: {
            user_id: "c68bf142-1b39-4e2b-81dc-d10592765e3a",
            username: "bva",
          },
        },
        {
          message_id: "0e180088-4be3-417a-bec9-0a9d3b20f730",
          message_type: "text",
          content: "7",
          content_url: "",
          created_at: "2025-02-11T09:05:51.015221",
          sender: {
            user_id: "c68bf142-1b39-4e2b-81dc-d10592765e3a",
            username: "bva",
          },
        },
        {
          message_id: "67ee340f-afed-4981-b359-6cd8f3245e25",
          message_type: "text",
          content: "6",
          content_url: "",
          created_at: "2025-02-11T09:05:46.855627",
          sender: {
            user_id: "c68bf142-1b39-4e2b-81dc-d10592765e3a",
            username: "bva",
          },
        },
        {
          message_id: "648cf433-576a-4def-a7f6-0a4f223df4c5",
          message_type: "text",
          content: "5",
          content_url: "",
          created_at: "2025-02-11T08:44:37.771504",
          sender: {
            user_id: "c68bf142-1b39-4e2b-81dc-d10592765e3a",
            username: "bva",
          },
        },
        {
          message_id: "3045e13d-1b8a-4f0c-a5d0-53d3c814e847",
          message_type: "text",
          content: "4",
          content_url: "",
          created_at: "2025-02-11T08:44:34.903762",
          sender: {
            user_id: "c68bf142-1b39-4e2b-81dc-d10592765e3a",
            username: "bva",
          },
        },
        {
          message_id: "86aa879b-5b8a-4132-87b5-ec88eb87ce26",
          message_type: "text",
          content: "3",
          content_url: "",
          created_at: "2025-02-11T08:44:32.470004",
          sender: {
            user_id: "c68bf142-1b39-4e2b-81dc-d10592765e3a",
            username: "bva",
          },
        },
        {
          message_id: "cef55fbf-8c66-46eb-9c69-d0ed373cd364",
          message_type: "text",
          content: "2",
          content_url: "",
          created_at: "2025-02-11T08:44:29.956543",
          sender: {
            user_id: "c68bf142-1b39-4e2b-81dc-d10592765e3a",
            username: "bva",
          },
        },
      ],
      context_after: [
        {
          message_id: "226628c5-503b-4173-8dbf-b6e0ad0b185d",
          message_type: "text",
          content: "10",
          content_url: "",
          created_at: "2025-02-11T09:05:59.969278",
          sender: {
            user_id: "c68bf142-1b39-4e2b-81dc-d10592765e3a",
            username: "bva",
          },
        },
        {
          message_id: "ed540751-7048-4b9f-aff2-c4375c5028eb",
          message_type: "text",
          content: "Channel to my welcome",
          content_url: "",
          created_at: "2025-02-12T06:16:04.886045",
          sender: {
            user_id: "45020e49-af98-40fe-8ea5-c2ff87ce27e3",
            username: "Kalua",
          },
        },
        {
          message_id: "e2d6850f-8107-4362-ab05-5452c2c56b62",
          message_type: "text",
          content: "belachi nagin nigali\\u2026",
          content_url: "",
          created_at: "2025-02-13T09:30:13.917224",
          sender: {
            user_id: "93829897-15ad-4537-a12b-acb882a55db0",
            username: "wicketsunny",
          },
        },
        {
          message_id: "df2943d1-d331-444b-9c1b-9f51c8abba00",
          message_type: "text",
          content: "Test message",
          content_url: "",
          created_at: "2025-02-17T05:01:46.745336",
          sender: {
            user_id: "16a272b5-f722-40e8-8fff-be95394ccbbe",
            username: "puja",
          },
        },
      ],
    },
    {
      reporter: {
        user_id: "2d323eaa-8c2b-400c-97d3-8b0452638378",
        username: "arvind",
      },
      reported_message: {
        message_id: "9c6d63d2-5871-4273-ae2c-905fe859bd6a",
        chat_id: "sr:match:57966995",
        message_type: "text",
        content_url: "",
        content: "2",
        created_at: "2025-02-11T11:25:13.794640",
        sender: {
          user_id: "c15897f3-6bdd-43c5-9bec-fff76eb8bc30",
          username: "KP",
        },
      },
      report_reason: "False information",
      report_desc: "Test",
      created_at: "2025-02-11T11:40:58.988022",
      status: "open",
      context_before: [
        {
          message_id: "c769a6b6-f6a0-48ed-a8a0-8e7d30aaaa1d",
          message_type: "text",
          content: "1",
          content_url: "",
          created_at: "2025-02-11T11:25:11.204102",
          sender: {
            user_id: "c15897f3-6bdd-43c5-9bec-fff76eb8bc30",
            username: "KP",
          },
        },
        {
          message_id: "65589e92-c198-4d20-be10-3085bd63204d",
          message_type: "text",
          content: "Testing live",
          content_url: "",
          created_at: "2025-02-11T11:24:52.718681",
          sender: {
            user_id: "c15897f3-6bdd-43c5-9bec-fff76eb8bc30",
            username: "KP",
          },
        },
        {
          message_id: "870caa3f-64c9-42f7-8070-e2eb0e0e0141",
          message_type: "text",
          content: "Test",
          content_url: "",
          created_at: "2025-02-11T11:17:11.617875",
          sender: {
            user_id: "c15897f3-6bdd-43c5-9bec-fff76eb8bc30",
            username: "KP",
          },
        },
        {
          message_id: "b88950d1-f51d-4c54-a427-9973004c8553",
          message_type: "text",
          content: "Hello",
          content_url: "",
          created_at: "2025-02-11T11:16:29.452550",
          sender: {
            user_id: "c15897f3-6bdd-43c5-9bec-fff76eb8bc30",
            username: "KP",
          },
        },
        {
          message_id: "2d0ca8c4-a385-49d4-b723-8e8050005036",
          message_type: "text",
          content: "Testing",
          content_url: "",
          created_at: "2025-02-11T11:15:51.765999",
          sender: {
            user_id: "2d323eaa-8c2b-400c-97d3-8b0452638378",
            username: "arvind",
          },
        },
        {
          message_id: "7696af9d-ddda-4cdb-8026-0d47381e992a",
          message_type: "text",
          content: "Hello",
          content_url: "",
          created_at: "2025-02-11T11:15:45.842908",
          sender: {
            user_id: "2d323eaa-8c2b-400c-97d3-8b0452638378",
            username: "arvind",
          },
        },
        {
          message_id: "737b0c68-f938-4c04-8824-91c7843dda19",
          message_type: "text",
          content: "Hello",
          content_url: "",
          created_at: "2025-02-11T11:15:20.594625",
          sender: {
            user_id: "2d323eaa-8c2b-400c-97d3-8b0452638378",
            username: "arvind",
          },
        },
      ],
      context_after: [
        {
          message_id: "c6251e00-e6a0-45dc-9393-59367211dccc",
          message_type: "text",
          content: "3",
          content_url: "",
          created_at: "2025-02-11T11:25:15.924647",
          sender: {
            user_id: "c15897f3-6bdd-43c5-9bec-fff76eb8bc30",
            username: "KP",
          },
        },
        {
          message_id: "7e267798-205c-493a-bbda-53dfd8fea8b0",
          message_type: "text",
          content: "4",
          content_url: "",
          created_at: "2025-02-11T11:25:18.294369",
          sender: {
            user_id: "c15897f3-6bdd-43c5-9bec-fff76eb8bc30",
            username: "KP",
          },
        },
        {
          message_id: "89c78a5e-396e-46ee-852b-6e804514afd2",
          message_type: "text",
          content: "5",
          content_url: "",
          created_at: "2025-02-11T11:25:21.114032",
          sender: {
            user_id: "c15897f3-6bdd-43c5-9bec-fff76eb8bc30",
            username: "KP",
          },
        },
        {
          message_id: "983f964d-35f9-4289-81a9-48cfd55d224d",
          message_type: "text",
          content: "6",
          content_url: "",
          created_at: "2025-02-11T11:25:23.329598",
          sender: {
            user_id: "c15897f3-6bdd-43c5-9bec-fff76eb8bc30",
            username: "KP",
          },
        },
        {
          message_id: "2d6b4263-14ad-46a7-812b-decea951e3be",
          message_type: "text",
          content: "7",
          content_url: "",
          created_at: "2025-02-11T11:25:26.252699",
          sender: {
            user_id: "c15897f3-6bdd-43c5-9bec-fff76eb8bc30",
            username: "KP",
          },
        },
        {
          message_id: "39148678-f8d3-488f-85a0-b1fd227d6cce",
          message_type: "text",
          content: "8",
          content_url: "",
          created_at: "2025-02-11T11:25:30.633441",
          sender: {
            user_id: "c15897f3-6bdd-43c5-9bec-fff76eb8bc30",
            username: "KP",
          },
        },
        {
          message_id: "39373a99-0a50-40f4-95b1-95264cd659f4",
          message_type: "text",
          content: "9",
          content_url: "",
          created_at: "2025-02-11T11:25:34.366860",
          sender: {
            user_id: "c15897f3-6bdd-43c5-9bec-fff76eb8bc30",
            username: "KP",
          },
        },
      ],
    },
    {
      reporter: {
        user_id: "c68bf142-1b39-4e2b-81dc-d10592765e3a",
        username: "bva",
      },
      reported_message: {
        message_id: "14f42996-ce6e-4d0e-adb1-9e4d2dec4b0b",
        chat_id: "rebet_global_chat",
        message_type: "text",
        content_url: "",
        content: "Hello channel welcom to my guys.",
        created_at: "2025-02-07T05:13:15.445712",
        sender: {
          user_id: "93829897-15ad-4537-a12b-acb882a55db0",
          username: "wicketsunny",
        },
      },
      report_reason: "Others",
      report_desc: "Test",
      created_at: "2025-02-11T09:08:41.340112",
      status: "open",
      context_before: [
        {
          message_id: "7dc1e4b7-eec3-4b86-9a8c-e171dda0aab7",
          message_type: "text",
          content: "\\ud83d\\udd25 \\ud83d\\udd25 \\ud83d\\udd25",
          content_url: "",
          created_at: "2025-02-06T08:12:04.412684",
          sender: {
            user_id: "8e5494b1-b81e-48ec-8873-43d1c330a259",
            username: "score.p",
          },
        },
        {
          message_id: "abce0aab-a80b-4f21-906f-6e57dc8e0e12",
          message_type: "text",
          content: "Hello @con",
          content_url: "",
          created_at: "2025-02-05T19:05:35.462364",
          sender: {
            user_id: "146cce61-84b9-4105-beef-0897e2987e33",
            username: "maxlat17",
          },
        },
        {
          message_id: "131170c3-6f8b-4276-a2d0-a55d25fc1568",
          message_type: "text",
          content: "Going global soon",
          content_url: "",
          created_at: "2025-02-05T19:02:38.728159",
          sender: {
            user_id: "146cce61-84b9-4105-beef-0897e2987e33",
            username: "maxlat17",
          },
        },
        {
          message_id: "098f1af8-5a3b-49e0-a6cd-2e0dbb432970",
          message_type: "text",
          content: "Hello all",
          content_url: "",
          created_at: "2025-02-05T19:02:25.756089",
          sender: {
            user_id: "146cce61-84b9-4105-beef-0897e2987e33",
            username: "maxlat17",
          },
        },
        {
          message_id: "965f9249-759d-4911-9f97-43029ffa32c4",
          message_type: "text",
          content: "Hello Global chat",
          content_url: "",
          created_at: "2025-02-05T17:04:33.133243",
          sender: {
            user_id: "61f4d8b0-22cf-44b4-b435-81726cc9580b",
            username: "con",
          },
        },
        {
          message_id: "60f64b25-1026-4c2a-a264-ca20708e275c",
          message_type: "text",
          content: "Testing chat",
          content_url: "",
          created_at: "2025-01-30T13:03:52.495095",
          sender: {
            user_id: "2d323eaa-8c2b-400c-97d3-8b0452638378",
            username: "arvind",
          },
        },
        {
          message_id: "c56cb5d0-3839-4e31-9241-0c0d50854e02",
          message_type: "text",
          content: "Chat test",
          content_url: "",
          created_at: "2025-01-30T13:02:20.276848",
          sender: {
            user_id: "c15897f3-6bdd-43c5-9bec-fff76eb8bc30",
            username: "KP",
          },
        },
      ],
      context_after: [
        {
          message_id: "177f3e72-a34d-4ca5-8907-44596b9187bc",
          message_type: "text",
          content:
            "The only thing you can think \\ud83e\\udd14 I think \\ud83d\\udcad the best",
          content_url: "",
          created_at: "2025-02-07T06:37:26.399030",
          sender: {
            user_id: "45020e49-af98-40fe-8ea5-c2ff87ce27e3",
            username: "Kalua",
          },
        },
        {
          message_id: "e1b1f155-6bd0-419b-a686-5dfd6c36126e",
          message_type: "text",
          content: "I\\u2019m",
          content_url: "",
          created_at: "2025-02-07T06:57:55.908502",
          sender: {
            user_id: "45020e49-af98-40fe-8ea5-c2ff87ce27e3",
            username: "Kalua",
          },
        },
        {
          message_id: "1700f798-8237-4e36-957a-d8ee872cc3a3",
          message_type: "text",
          content: "I\\u2019m",
          content_url: "",
          created_at: "2025-02-07T06:57:56.377462",
          sender: {
            user_id: "45020e49-af98-40fe-8ea5-c2ff87ce27e3",
            username: "Kalua",
          },
        },
        {
          message_id: "a65344e5-7f1b-4d81-bbb4-18b855599341",
          message_type: "text",
          content: "Hello channel welcom to my guys.",
          content_url: "",
          created_at: "2025-02-11T05:58:46.040163",
          sender: {
            user_id: "c68bf142-1b39-4e2b-81dc-d10592765e3a",
            username: "bva",
          },
        },
        {
          message_id: "7c0250c6-9d57-4cba-a90e-9cb3e5431c8c",
          message_type: "text",
          content: "Hi",
          content_url: "",
          created_at: "2025-02-11T06:06:55.234071",
          sender: {
            user_id: "c68bf142-1b39-4e2b-81dc-d10592765e3a",
            username: "bva",
          },
        },
        {
          message_id: "1fb52545-8f35-4510-ba0c-f6609cf69c3a",
          message_type: "text",
          content: "Testing",
          content_url: "",
          created_at: "2025-02-11T06:07:06.113154",
          sender: {
            user_id: "c68bf142-1b39-4e2b-81dc-d10592765e3a",
            username: "bva",
          },
        },
        {
          message_id: "e93ecf11-7635-480e-b72c-55d5c6e7d60d",
          message_type: "text",
          content: "Test",
          content_url: "",
          created_at: "2025-02-11T08:42:27.844909",
          sender: {
            user_id: "c68bf142-1b39-4e2b-81dc-d10592765e3a",
            username: "bva",
          },
        },
      ],
    },
    {
      reporter: {
        user_id: "93829897-15ad-4537-a12b-acb882a55db0",
        username: "wicketsunny",
      },
      reported_message: {
        message_id: "60f64b25-1026-4c2a-a264-ca20708e275c",
        chat_id: "rebet_global_chat",
        message_type: "text",
        content_url: "",
        content: "Testing chat",
        created_at: "2025-01-30T13:03:52.495095",
        sender: {
          user_id: "2d323eaa-8c2b-400c-97d3-8b0452638378",
          username: "arvind",
        },
      },
      report_reason: "False information",
      report_desc: "EY EDE",
      created_at: "2025-02-07T08:46:27.101812",
      status: "open",
      context_before: [
        {
          message_id: "c56cb5d0-3839-4e31-9241-0c0d50854e02",
          message_type: "text",
          content: "Chat test",
          content_url: "",
          created_at: "2025-01-30T13:02:20.276848",
          sender: {
            user_id: "c15897f3-6bdd-43c5-9bec-fff76eb8bc30",
            username: "KP",
          },
        },
        {
          message_id: "4851b1d3-0220-48ef-96fd-bfe38654c3ee",
          message_type: "text",
          content: "Live global chat",
          content_url: "",
          created_at: "2025-01-30T13:01:03.401746",
          sender: {
            user_id: "c15897f3-6bdd-43c5-9bec-fff76eb8bc30",
            username: "KP",
          },
        },
        {
          message_id: "c48c1d4e-43a7-424e-a04a-cd9de6659e05",
          message_type: "text",
          content: "Live test",
          content_url: "",
          created_at: "2025-01-30T13:00:10.922106",
          sender: {
            user_id: "c15897f3-6bdd-43c5-9bec-fff76eb8bc30",
            username: "KP",
          },
        },
        {
          message_id: "5fbbf6b4-fb37-4581-9e20-4fd3c51eff74",
          message_type: "text",
          content: "Testing",
          content_url: "",
          created_at: "2025-01-30T12:55:01.701711",
          sender: {
            user_id: "c15897f3-6bdd-43c5-9bec-fff76eb8bc30",
            username: "KP",
          },
        },
        {
          message_id: "ec59be50-6879-4dbc-abcd-76e9930699a8",
          message_type: "text",
          content: "Live test",
          content_url: "",
          created_at: "2025-01-30T12:53:45.538609",
          sender: {
            user_id: "c15897f3-6bdd-43c5-9bec-fff76eb8bc30",
            username: "KP",
          },
        },
        {
          message_id: "a3b73494-360e-4c3d-b201-b7f5dec5e4a6",
          message_type: "text",
          content: "Testing live",
          content_url: "",
          created_at: "2025-01-30T12:51:31.835495",
          sender: {
            user_id: "c15897f3-6bdd-43c5-9bec-fff76eb8bc30",
            username: "KP",
          },
        },
        {
          message_id: "72194318-a185-4120-9bc1-bb4d1558c202",
          message_type: "text",
          content: "Live test",
          content_url: "",
          created_at: "2025-01-30T12:45:32.976332",
          sender: {
            user_id: "c15897f3-6bdd-43c5-9bec-fff76eb8bc30",
            username: "KP",
          },
        },
      ],
      context_after: [
        {
          message_id: "965f9249-759d-4911-9f97-43029ffa32c4",
          message_type: "text",
          content: "Hello Global chat",
          content_url: "",
          created_at: "2025-02-05T17:04:33.133243",
          sender: {
            user_id: "61f4d8b0-22cf-44b4-b435-81726cc9580b",
            username: "con",
          },
        },
        {
          message_id: "098f1af8-5a3b-49e0-a6cd-2e0dbb432970",
          message_type: "text",
          content: "Hello all",
          content_url: "",
          created_at: "2025-02-05T19:02:25.756089",
          sender: {
            user_id: "146cce61-84b9-4105-beef-0897e2987e33",
            username: "maxlat17",
          },
        },
        {
          message_id: "131170c3-6f8b-4276-a2d0-a55d25fc1568",
          message_type: "text",
          content: "Going global soon",
          content_url: "",
          created_at: "2025-02-05T19:02:38.728159",
          sender: {
            user_id: "146cce61-84b9-4105-beef-0897e2987e33",
            username: "maxlat17",
          },
        },
        {
          message_id: "abce0aab-a80b-4f21-906f-6e57dc8e0e12",
          message_type: "text",
          content: "Hello @con",
          content_url: "",
          created_at: "2025-02-05T19:05:35.462364",
          sender: {
            user_id: "146cce61-84b9-4105-beef-0897e2987e33",
            username: "maxlat17",
          },
        },
        {
          message_id: "7dc1e4b7-eec3-4b86-9a8c-e171dda0aab7",
          message_type: "text",
          content: "\\ud83d\\udd25 \\ud83d\\udd25 \\ud83d\\udd25",
          content_url: "",
          created_at: "2025-02-06T08:12:04.412684",
          sender: {
            user_id: "8e5494b1-b81e-48ec-8873-43d1c330a259",
            username: "score.p",
          },
        },
        {
          message_id: "14f42996-ce6e-4d0e-adb1-9e4d2dec4b0b",
          message_type: "text",
          content: "Hello channel welcom to my guys.",
          content_url: "",
          created_at: "2025-02-07T05:13:15.445712",
          sender: {
            user_id: "93829897-15ad-4537-a12b-acb882a55db0",
            username: "wicketsunny",
          },
        },
        {
          message_id: "177f3e72-a34d-4ca5-8907-44596b9187bc",
          message_type: "text",
          content:
            "The only thing you can think \\ud83e\\udd14 I think \\ud83d\\udcad the best",
          content_url: "",
          created_at: "2025-02-07T06:37:26.399030",
          sender: {
            user_id: "45020e49-af98-40fe-8ea5-c2ff87ce27e3",
            username: "Kalua",
          },
        },
      ],
    },
    {
      reporter: {
        user_id: "45020e49-af98-40fe-8ea5-c2ff87ce27e3",
        username: "Kalua",
      },
      reported_message: {
        message_id: "131170c3-6f8b-4276-a2d0-a55d25fc1568",
        chat_id: "rebet_global_chat",
        message_type: "text",
        content_url: "",
        content: "Going global soon",
        created_at: "2025-02-05T19:02:38.728159",
        sender: {
          user_id: "146cce61-84b9-4105-beef-0897e2987e33",
          username: "maxlat17",
        },
      },
      report_reason: "Others",
      report_desc: "Okay sir",
      created_at: "2025-02-07T07:00:14.994475",
      status: "open",
      context_before: [
        {
          message_id: "098f1af8-5a3b-49e0-a6cd-2e0dbb432970",
          message_type: "text",
          content: "Hello all",
          content_url: "",
          created_at: "2025-02-05T19:02:25.756089",
          sender: {
            user_id: "146cce61-84b9-4105-beef-0897e2987e33",
            username: "maxlat17",
          },
        },
        {
          message_id: "965f9249-759d-4911-9f97-43029ffa32c4",
          message_type: "text",
          content: "Hello Global chat",
          content_url: "",
          created_at: "2025-02-05T17:04:33.133243",
          sender: {
            user_id: "61f4d8b0-22cf-44b4-b435-81726cc9580b",
            username: "con",
          },
        },
        {
          message_id: "60f64b25-1026-4c2a-a264-ca20708e275c",
          message_type: "text",
          content: "Testing chat",
          content_url: "",
          created_at: "2025-01-30T13:03:52.495095",
          sender: {
            user_id: "2d323eaa-8c2b-400c-97d3-8b0452638378",
            username: "arvind",
          },
        },
        {
          message_id: "c56cb5d0-3839-4e31-9241-0c0d50854e02",
          message_type: "text",
          content: "Chat test",
          content_url: "",
          created_at: "2025-01-30T13:02:20.276848",
          sender: {
            user_id: "c15897f3-6bdd-43c5-9bec-fff76eb8bc30",
            username: "KP",
          },
        },
        {
          message_id: "4851b1d3-0220-48ef-96fd-bfe38654c3ee",
          message_type: "text",
          content: "Live global chat",
          content_url: "",
          created_at: "2025-01-30T13:01:03.401746",
          sender: {
            user_id: "c15897f3-6bdd-43c5-9bec-fff76eb8bc30",
            username: "KP",
          },
        },
        {
          message_id: "c48c1d4e-43a7-424e-a04a-cd9de6659e05",
          message_type: "text",
          content: "Live test",
          content_url: "",
          created_at: "2025-01-30T13:00:10.922106",
          sender: {
            user_id: "c15897f3-6bdd-43c5-9bec-fff76eb8bc30",
            username: "KP",
          },
        },
        {
          message_id: "5fbbf6b4-fb37-4581-9e20-4fd3c51eff74",
          message_type: "text",
          content: "Testing",
          content_url: "",
          created_at: "2025-01-30T12:55:01.701711",
          sender: {
            user_id: "c15897f3-6bdd-43c5-9bec-fff76eb8bc30",
            username: "KP",
          },
        },
      ],
      context_after: [
        {
          message_id: "abce0aab-a80b-4f21-906f-6e57dc8e0e12",
          message_type: "text",
          content: "Hello @con",
          content_url: "",
          created_at: "2025-02-05T19:05:35.462364",
          sender: {
            user_id: "146cce61-84b9-4105-beef-0897e2987e33",
            username: "maxlat17",
          },
        },
        {
          message_id: "7dc1e4b7-eec3-4b86-9a8c-e171dda0aab7",
          message_type: "text",
          content: "\\ud83d\\udd25 \\ud83d\\udd25 \\ud83d\\udd25",
          content_url: "",
          created_at: "2025-02-06T08:12:04.412684",
          sender: {
            user_id: "8e5494b1-b81e-48ec-8873-43d1c330a259",
            username: "score.p",
          },
        },
        {
          message_id: "14f42996-ce6e-4d0e-adb1-9e4d2dec4b0b",
          message_type: "text",
          content: "Hello channel welcom to my guys.",
          content_url: "",
          created_at: "2025-02-07T05:13:15.445712",
          sender: {
            user_id: "93829897-15ad-4537-a12b-acb882a55db0",
            username: "wicketsunny",
          },
        },
        {
          message_id: "177f3e72-a34d-4ca5-8907-44596b9187bc",
          message_type: "text",
          content:
            "The only thing you can think \\ud83e\\udd14 I think \\ud83d\\udcad the best",
          content_url: "",
          created_at: "2025-02-07T06:37:26.399030",
          sender: {
            user_id: "45020e49-af98-40fe-8ea5-c2ff87ce27e3",
            username: "Kalua",
          },
        },
        {
          message_id: "e1b1f155-6bd0-419b-a686-5dfd6c36126e",
          message_type: "text",
          content: "I\\u2019m",
          content_url: "",
          created_at: "2025-02-07T06:57:55.908502",
          sender: {
            user_id: "45020e49-af98-40fe-8ea5-c2ff87ce27e3",
            username: "Kalua",
          },
        },
        {
          message_id: "1700f798-8237-4e36-957a-d8ee872cc3a3",
          message_type: "text",
          content: "I\\u2019m",
          content_url: "",
          created_at: "2025-02-07T06:57:56.377462",
          sender: {
            user_id: "45020e49-af98-40fe-8ea5-c2ff87ce27e3",
            username: "Kalua",
          },
        },
        {
          message_id: "a65344e5-7f1b-4d81-bbb4-18b855599341",
          message_type: "text",
          content: "Hello channel welcom to my guys.",
          content_url: "",
          created_at: "2025-02-11T05:58:46.040163",
          sender: {
            user_id: "c68bf142-1b39-4e2b-81dc-d10592765e3a",
            username: "bva",
          },
        },
      ],
    },
    {
      reporter: {
        user_id: "45020e49-af98-40fe-8ea5-c2ff87ce27e3",
        username: "Kalua",
      },
      reported_message: {
        message_id: "5410dae0-4d01-43fb-a3f0-48f5c79b19ec",
        chat_id: "sr:match:57869847",
        message_type: "text",
        content_url: "",
        content: "hey kunal",
        created_at: "2025-02-07T06:34:23.070000",
        sender: {
          user_id: "93829897-15ad-4537-a12b-acb882a55db0",
          username: "wicketsunny",
        },
      },
      report_reason: "Propaganda of terrorism",
      report_desc: "Ha bolo",
      created_at: "2025-02-07T06:59:40.771655",
      status: "open",
      context_before: [
        {
          message_id: "7265dc3c-4890-4f60-a1e7-f990f0bfd463",
          message_type: "text",
          content: "Kunal look here",
          content_url: "",
          created_at: "2025-02-07T06:34:15.454092",
          sender: {
            user_id: "93829897-15ad-4537-a12b-acb882a55db0",
            username: "wicketsunny",
          },
        },
        {
          message_id: "d799d66b-001a-4b8c-808b-f52d297f494f",
          message_type: "text",
          content: "hi",
          content_url: "",
          created_at: "2025-02-07T06:34:12.530725",
          sender: {
            user_id: "8e5494b1-b81e-48ec-8873-43d1c330a259",
            username: "score.p",
          },
        },
        {
          message_id: "9992c87f-1f52-42a0-9fdc-1aef72350330",
          message_type: "text",
          content: "hey",
          content_url: "",
          created_at: "2025-02-07T06:33:49.354032",
          sender: {
            user_id: "93829897-15ad-4537-a12b-acb882a55db0",
            username: "wicketsunny",
          },
        },
      ],
      context_after: [
        {
          message_id: "9fd2e65b-8c48-468d-8677-7c8fbf5ab4cd",
          message_type: "text",
          content: "chasma laga ke dekho",
          content_url: "",
          created_at: "2025-02-07T06:34:28.128266",
          sender: {
            user_id: "8e5494b1-b81e-48ec-8873-43d1c330a259",
            username: "score.p",
          },
        },
        {
          message_id: "df92fdd5-ea59-4cdb-9aff-9923b767d2a1",
          message_type: "text",
          content: "Mila",
          content_url: "",
          created_at: "2025-02-07T06:34:29.315554",
          sender: {
            user_id: "45020e49-af98-40fe-8ea5-c2ff87ce27e3",
            username: "Kalua",
          },
        },
        {
          message_id: "a302c199-7d6f-4d33-9ea2-d0967a1867e4",
          message_type: "text",
          content: "Nice",
          content_url: "",
          created_at: "2025-02-07T06:34:35.191466",
          sender: {
            user_id: "45020e49-af98-40fe-8ea5-c2ff87ce27e3",
            username: "Kalua",
          },
        },
        {
          message_id: "95b26edd-b425-442e-9ca1-29a95dc76ed5",
          message_type: "text",
          content: "Nice",
          content_url: "",
          created_at: "2025-02-07T06:34:35.226623",
          sender: {
            user_id: "45020e49-af98-40fe-8ea5-c2ff87ce27e3",
            username: "Kalua",
          },
        },
        {
          message_id: "f7be2ae3-0dd5-4ea1-8d67-cdcec1363330",
          message_type: "text",
          content: "Nice",
          content_url: "",
          created_at: "2025-02-07T06:34:35.338133",
          sender: {
            user_id: "45020e49-af98-40fe-8ea5-c2ff87ce27e3",
            username: "Kalua",
          },
        },
        {
          message_id: "ff53af05-b092-40cd-8a30-70cceabf7f97",
          message_type: "text",
          content: "moj kar",
          content_url: "",
          created_at: "2025-02-07T06:34:49.356185",
          sender: {
            user_id: "8e5494b1-b81e-48ec-8873-43d1c330a259",
            username: "score.p",
          },
        },
        {
          message_id: "e0f96ffa-08ec-47df-b900-b488c7a07969",
          message_type: "text",
          content: "Ye Kya double he what\\u2019s is this Arvind bhai",
          content_url: "",
          created_at: "2025-02-07T06:34:53.458883",
          sender: {
            user_id: "45020e49-af98-40fe-8ea5-c2ff87ce27e3",
            username: "Kalua",
          },
        },
      ],
    },
    {
      reporter: {
        user_id: "45020e49-af98-40fe-8ea5-c2ff87ce27e3",
        username: "Kalua",
      },
      reported_message: {
        message_id: "ff53af05-b092-40cd-8a30-70cceabf7f97",
        chat_id: "sr:match:57869847",
        message_type: "text",
        content_url: "",
        content: "moj kar",
        created_at: "2025-02-07T06:34:49.356185",
        sender: {
          user_id: "8e5494b1-b81e-48ec-8873-43d1c330a259",
          username: "score.p",
        },
      },
      report_reason: "Suicide or self-mutilation",
      report_desc: "Not bad ",
      created_at: "2025-02-07T06:59:23.154087",
      status: "open",
      context_before: [
        {
          message_id: "f7be2ae3-0dd5-4ea1-8d67-cdcec1363330",
          message_type: "text",
          content: "Nice",
          content_url: "",
          created_at: "2025-02-07T06:34:35.338133",
          sender: {
            user_id: "45020e49-af98-40fe-8ea5-c2ff87ce27e3",
            username: "Kalua",
          },
        },
        {
          message_id: "95b26edd-b425-442e-9ca1-29a95dc76ed5",
          message_type: "text",
          content: "Nice",
          content_url: "",
          created_at: "2025-02-07T06:34:35.226623",
          sender: {
            user_id: "45020e49-af98-40fe-8ea5-c2ff87ce27e3",
            username: "Kalua",
          },
        },
        {
          message_id: "a302c199-7d6f-4d33-9ea2-d0967a1867e4",
          message_type: "text",
          content: "Nice",
          content_url: "",
          created_at: "2025-02-07T06:34:35.191466",
          sender: {
            user_id: "45020e49-af98-40fe-8ea5-c2ff87ce27e3",
            username: "Kalua",
          },
        },
        {
          message_id: "df92fdd5-ea59-4cdb-9aff-9923b767d2a1",
          message_type: "text",
          content: "Mila",
          content_url: "",
          created_at: "2025-02-07T06:34:29.315554",
          sender: {
            user_id: "45020e49-af98-40fe-8ea5-c2ff87ce27e3",
            username: "Kalua",
          },
        },
        {
          message_id: "9fd2e65b-8c48-468d-8677-7c8fbf5ab4cd",
          message_type: "text",
          content: "chasma laga ke dekho",
          content_url: "",
          created_at: "2025-02-07T06:34:28.128266",
          sender: {
            user_id: "8e5494b1-b81e-48ec-8873-43d1c330a259",
            username: "score.p",
          },
        },
        {
          message_id: "5410dae0-4d01-43fb-a3f0-48f5c79b19ec",
          message_type: "text",
          content: "hey kunal",
          content_url: "",
          created_at: "2025-02-07T06:34:23.070000",
          sender: {
            user_id: "93829897-15ad-4537-a12b-acb882a55db0",
            username: "wicketsunny",
          },
        },
        {
          message_id: "7265dc3c-4890-4f60-a1e7-f990f0bfd463",
          message_type: "text",
          content: "Kunal look here",
          content_url: "",
          created_at: "2025-02-07T06:34:15.454092",
          sender: {
            user_id: "93829897-15ad-4537-a12b-acb882a55db0",
            username: "wicketsunny",
          },
        },
      ],
      context_after: [
        {
          message_id: "e0f96ffa-08ec-47df-b900-b488c7a07969",
          message_type: "text",
          content: "Ye Kya double he what\\u2019s is this Arvind bhai",
          content_url: "",
          created_at: "2025-02-07T06:34:53.458883",
          sender: {
            user_id: "45020e49-af98-40fe-8ea5-c2ff87ce27e3",
            username: "Kalua",
          },
        },
        {
          message_id: "68e2958b-af86-4a2b-ba3e-5fd18610d892",
          message_type: "text",
          content: "Ye Kya double he what\\u2019s is this Arvind bhai",
          content_url: "",
          created_at: "2025-02-07T06:34:53.543380",
          sender: {
            user_id: "45020e49-af98-40fe-8ea5-c2ff87ce27e3",
            username: "Kalua",
          },
        },
        {
          message_id: "10882f1d-4e89-4375-96ae-deaf03476887",
          message_type: "text",
          content: "Ye Kya double he what\\u2019s is this Arvind bhai",
          content_url: "",
          created_at: "2025-02-07T06:34:53.606276",
          sender: {
            user_id: "45020e49-af98-40fe-8ea5-c2ff87ce27e3",
            username: "Kalua",
          },
        },
        {
          message_id: "f996cdeb-1afc-47cf-8436-445dcdcf6f03",
          message_type: "text",
          content: "Ye Kya double he what\\u2019s is this Arvind bhai",
          content_url: "",
          created_at: "2025-02-07T06:34:53.823807",
          sender: {
            user_id: "45020e49-af98-40fe-8ea5-c2ff87ce27e3",
            username: "Kalua",
          },
        },
        {
          message_id: "e15a580f-0326-4140-b7f1-0900c688747e",
          message_type: "text",
          content: "Ye Kya double he what\\u2019s is this Arvind bhai",
          content_url: "",
          created_at: "2025-02-07T06:34:53.906373",
          sender: {
            user_id: "45020e49-af98-40fe-8ea5-c2ff87ce27e3",
            username: "Kalua",
          },
        },
        {
          message_id: "9501f38e-2e05-4666-bdbf-e7cb5a9f0c17",
          message_type: "text",
          content: "Ye Kya double he what\\u2019s is this Arvind bhai",
          content_url: "",
          created_at: "2025-02-07T06:34:53.970335",
          sender: {
            user_id: "45020e49-af98-40fe-8ea5-c2ff87ce27e3",
            username: "Kalua",
          },
        },
        {
          message_id: "49b531ea-e681-477f-91d7-3893b5a2d49b",
          message_type: "text",
          content: "Ye Kya double he what\\u2019s is this Arvind bhai",
          content_url: "",
          created_at: "2025-02-07T06:34:54.114914",
          sender: {
            user_id: "45020e49-af98-40fe-8ea5-c2ff87ce27e3",
            username: "Kalua",
          },
        },
      ],
    },
    {
      reporter: {
        user_id: "2d323eaa-8c2b-400c-97d3-8b0452638378",
        username: "arvind",
      },
      reported_message: {
        message_id: "771bbfad-8d1e-42ea-ad18-bcaae7997eb1",
        chat_id: "sr:match:56930783",
        message_type: "text",
        content_url: "",
        content: "Testing",
        created_at: "2025-02-06T12:49:38.516274",
        sender: {
          user_id: "c15897f3-6bdd-43c5-9bec-fff76eb8bc30",
          username: "KP",
        },
      },
      report_reason: "False information",
      report_desc: "Test",
      created_at: "2025-02-07T05:31:13.444440",
      status: "open",
      context_before: [
        {
          message_id: "00881ab6-84fe-4b15-97a0-f3efec564393",
          message_type: "text",
          content: "Hello",
          content_url: "",
          created_at: "2025-02-06T12:49:25.256164",
          sender: {
            user_id: "2d323eaa-8c2b-400c-97d3-8b0452638378",
            username: "arvind",
          },
        },
        {
          message_id: "db46ee1b-f75c-4049-aa24-3c2b3a5c27d6",
          message_type: "text",
          content: "Hello",
          content_url: "",
          created_at: "2025-02-06T12:49:14.961256",
          sender: {
            user_id: "c15897f3-6bdd-43c5-9bec-fff76eb8bc30",
            username: "KP",
          },
        },
      ],
      context_after: [
        {
          message_id: "bcb75da4-fa37-4500-a3f1-fa0ed0d2472a",
          message_type: "text",
          content: "Testing chat screen",
          content_url: "",
          created_at: "2025-02-06T12:49:46.568829",
          sender: {
            user_id: "2d323eaa-8c2b-400c-97d3-8b0452638378",
            username: "arvind",
          },
        },
      ],
    },
    {
      reporter: {
        user_id: "c15897f3-6bdd-43c5-9bec-fff76eb8bc30",
        username: "KP",
      },
      reported_message: {
        message_id: "bcb75da4-fa37-4500-a3f1-fa0ed0d2472a",
        chat_id: "sr:match:56930783",
        message_type: "text",
        content_url: "",
        content: "Testing chat screen",
        created_at: "2025-02-06T12:49:46.568829",
        sender: {
          user_id: "2d323eaa-8c2b-400c-97d3-8b0452638378",
          username: "arvind",
        },
      },
      report_reason: "False information",
      report_desc: "Test",
      created_at: "2025-02-07T05:30:51.441239",
      status: "open",
      context_before: [
        {
          message_id: "771bbfad-8d1e-42ea-ad18-bcaae7997eb1",
          message_type: "text",
          content: "Testing",
          content_url: "",
          created_at: "2025-02-06T12:49:38.516274",
          sender: {
            user_id: "c15897f3-6bdd-43c5-9bec-fff76eb8bc30",
            username: "KP",
          },
        },
        {
          message_id: "00881ab6-84fe-4b15-97a0-f3efec564393",
          message_type: "text",
          content: "Hello",
          content_url: "",
          created_at: "2025-02-06T12:49:25.256164",
          sender: {
            user_id: "2d323eaa-8c2b-400c-97d3-8b0452638378",
            username: "arvind",
          },
        },
        {
          message_id: "db46ee1b-f75c-4049-aa24-3c2b3a5c27d6",
          message_type: "text",
          content: "Hello",
          content_url: "",
          created_at: "2025-02-06T12:49:14.961256",
          sender: {
            user_id: "c15897f3-6bdd-43c5-9bec-fff76eb8bc30",
            username: "KP",
          },
        },
      ],
      context_after: [],
    },
    {
      reporter: {
        user_id: "c15897f3-6bdd-43c5-9bec-fff76eb8bc30",
        username: "KP",
      },
      reported_message: {
        message_id: "e65e1e94-e64d-4114-b52d-3f2512403d50",
        chat_id: "sr:match:52631461",
        message_type: "text",
        content_url: "",
        content: "Hello",
        created_at: "2025-02-07T05:28:27.519796",
        sender: {
          user_id: "2d323eaa-8c2b-400c-97d3-8b0452638378",
          username: "arvind",
        },
      },
      report_reason: "False information",
      report_desc: "Testing",
      created_at: "2025-02-07T05:29:30.355322",
      status: "open",
      context_before: [
        {
          message_id: "e0b6a1d2-7ca9-4261-b0ad-37bb81ece768",
          message_type: "text",
          content: "Hello",
          content_url: "",
          created_at: "2025-02-07T05:28:19.435509",
          sender: {
            user_id: "c15897f3-6bdd-43c5-9bec-fff76eb8bc30",
            username: "KP",
          },
        },
      ],
      context_after: [
        {
          message_id: "6d81fcc6-ce7a-4695-a36a-dcef8686d796",
          message_type: "text",
          content: "Testing",
          content_url: "",
          created_at: "2025-02-07T05:28:34.922547",
          sender: {
            user_id: "c15897f3-6bdd-43c5-9bec-fff76eb8bc30",
            username: "KP",
          },
        },
        {
          message_id: "cc831bd0-93c3-4463-9c56-2e494922aec5",
          message_type: "text",
          content: "Testing",
          content_url: "",
          created_at: "2025-02-07T05:28:43.685851",
          sender: {
            user_id: "2d323eaa-8c2b-400c-97d3-8b0452638378",
            username: "arvind",
          },
        },
        {
          message_id: "0c3d9cdc-013d-4b0d-812f-0d10d6623d71",
          message_type: "text",
          content: "Testing",
          content_url: "",
          created_at: "2025-02-07T05:28:44.325804",
          sender: {
            user_id: "2d323eaa-8c2b-400c-97d3-8b0452638378",
            username: "arvind",
          },
        },
      ],
    },
  ];

  const toggleExpand = (index) => {
    setExpandedReport(expandedReport === index ? null : index);
  };

  const getReports = async () => {
    setIsApiRunning(true);

    const params = {
      page: currentPage,
    };
    
    try {
      const response = await PrivateAdminPanelInstance?.post(
        API_ROUTES?.LIST_DM_REPORTS,
        params
      );
      const data = response?.data.data;
      setReports(data);
      setIsApiRunning(false);
    } catch (error) {
      setIsApiRunning(false);
      console.log("error reports", error);
    }
  };

  const closeReport = async (e, reporterId, messageId) => {
    e.stopPropagation();
    setErrorMessage("");
    setSuccessMessage("");

    let params = {
      user_id: reporterId,
      message_id: messageId,
    };

    try {
      await PrivateAdminPanelInstance?.post(
        API_ROUTES?.CLOSE_DM_REPORT,
        params
      );

      setSuccessMessage("Report closed successfully.");
      setTimeout(() => {
        setSuccessMessage("");
      }, 3000);
    } catch (error) {
      setErrorMessage(error.response.data.message);
    } finally {
      setIsApiRunning(false);
    }
  };

  const handleClickNext = () => {
    setCurrentPage((prev) => prev + 1);
  };

  const handleClickPrev = () => {
    if (currentPage === 1) return;
    setCurrentPage((prev) => prev - 1);
  };

  useEffect(() => {
    getReports();
  }, [currentPage]);

    useEffect(() => {
      setActiveSidebarTab(SIDER_TABS.REPORTS, "Reports");
    }, [setActiveSidebarTab]);

  return (
    <Layout name={SIDER_TABS.REPORTS}>
      <div className="reports-body-container">
        <div className="reports-body">
          <>
            <div className="head-controls">
              <div className="header-text-container">
                <p className="header-text">Reports</p>
                {errorMessage && (
                  <p className="error-message">{errorMessage}</p>
                )}
                {successMessage && (
                  <p className="success-message">{successMessage}</p>
                )}
              </div>
            </div>

            <div className="reports-container">
              {isApiRunning ? (
                <div className="loader-container">
                  <RebetLoader height={"100px"} width={"100px"} />
                </div>
              ) : (
                <>
                  {reports.length > 0 ? (
                    reports.map((report, index) => (
                      <div
                        key={index}
                        className={`report-card ${
                          expandedReport === index ? "expanded" : ""
                        }`}
                        onClick={() => toggleExpand(index)}
                      >
                        <div className="report-header">
                          <div>
                            <h3>
                              Report #{index + 1}
                              <span>
                                {expandedReport === index ? "-" : "+"}
                              </span>
                            </h3>
                            <div>
                              <p>Reporter: {report.reporter.username}</p>
                              <p>
                                Reported User:{" "}
                                {report.reported_message.sender.username}
                              </p>
                              <p>Reporter Message: {report.report_desc}</p>
                              <p>Reason: {report.report_reason}</p>
                            </div>
                          </div>
                          <div className="report-actions">
                            <button
                              className="mute-btn"
                              onClick={(e) =>
                                closeReport(
                                  e,
                                  report.reporter.user_id,
                                  report.reported_message.message_id
                                )
                              }
                            >
                              Close Report
                            </button>
                          </div>
                        </div>
                        <div className="report-body">
                          <p className="reported-message">
                            "{report.reported_message.content}"
                          </p>
                        </div>
                        {expandedReport === index && (
                          <div className="report-details">
                            <h4>Context Before:</h4>
                            <ul>
                              {report.context_before.map((msg) => (
                                <li key={msg.message_id}>
                                  <span className="username">
                                    {msg.sender.username}:
                                  </span>{" "}
                                  "{msg.content}"
                                </li>
                              ))}
                            </ul>
                            <h4>Context After:</h4>
                            <ul>
                              {report.context_after.map((msg) => (
                                <li key={msg.message_id}>
                                  <span className="username">
                                    {msg.sender.username}:
                                  </span>{" "}
                                  "{msg.content}"
                                </li>
                              ))}
                            </ul>
                          </div>
                        )}
                      </div>
                    ))
                  ) : (
                    <div className="no-reports-container">
                      There are no reports yet.
                    </div>
                  )}
                </>
              )}
            </div>
          </>
          {!isApiRunning && reports.length >= 10 && (
            <div className="table-controls-container">
              <p
                className={`prev-text ${currentPage === 1 ? "disabled" : ""}`}
                onClick={handleClickPrev}
              >
                Prev
              </p>
              <p className="current-page">{currentPage}</p>
              <p className="next-text" onClick={handleClickNext}>
                Next
              </p>
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
};

export default Reports;
